import { ClientDatumSource } from '@upright/common/model/company-client-data/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import { useInsightsLensContext } from '@upright/ui/common/upright/core/impact-lenses/insights/common/use-insights-lens-context';
import Skeleton from 'react-loading-skeleton';

export function InsightsSourceDescription() {
  const ctx = useInsightsLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.insights;
  if (!items) {
    return <>Error</>;
  }
  return <>{clientDatumSourceDescription(toSimplifiedSource(items))}</>;
}

export function toSimplifiedSource(data: Array<{ sourceType?: ClientDatumSource }>) {
  // if we find even one which is not COMPANY_SUBMITTED,
  // we return "Data collected by Upright"
  const foundSomethingNotCompanySubmitted = !!data.find(d => d.sourceType !== ClientDatumSource.COMPANY_SUBMITTED);
  if (foundSomethingNotCompanySubmitted) {
    return ClientDatumSource.UPRIGHT_COLLECTED;
  }
  return ClientDatumSource.COMPANY_SUBMITTED;
}

export function clientDatumSourceDescription(type: ClientDatumSource) {
  switch (type) {
    case ClientDatumSource.COMPANY_SUBMITTED:
      return 'Data provided by the company';
    case ClientDatumSource.UPRIGHT_COLLECTED:
      return 'Data collected by Upright';
  }
}
